import Cookies from 'js-cookie';
import React from 'react';
import { useLocation } from 'react-router';
import { Summary, Dashboard } from '|/app/services';
import { isCarvanaNativeApp } from '|/helpers/is-native-app/is-native-app';
import { isResolverRoute } from '|/helpers/is-resolver-route';
import HeaderMfe from './header-mfe';
import PurchaseHeader from './purchase-header';
import PurchaseHeaderTreatment from './purchase-header/treatment/purchase-header-treatment';

interface CarvanaHeaderProps {
  orderSummary?: Summary | null;
  dashboard?: Dashboard | null;
  isOrderSummaryModalOpen?: boolean;
  setIsOrderSummaryModalOpen?: (isOpen: boolean) => void;
}

function CarvanaHeader({
  orderSummary = null,
  dashboard = null,
  isOrderSummaryModalOpen,
  setIsOrderSummaryModalOpen
}: CarvanaHeaderProps) {
  const { pathname } = useLocation();
  const hideHeaderCookie = Cookies.get('hide-header') === 'true' ? true : false;
  const mobileUserAgent = isCarvanaNativeApp();
  const shouldHideHeader = mobileUserAgent && hideHeaderCookie;

  // The resolver routes only redirect, and for an order-placed customer the native webview
  // hands off via NAVIGATE_TO_OPD without navigating at all (use-next-step-vm.tsx) — so any
  // header painted here flashes until native swaps in OPD. TXCC-9813.
  if (mobileUserAgent && isResolverRoute(pathname)) {
    return null;
  }

  const showPurchaseHeader =
    !pathname.startsWith('/steps/order-placed') && !pathname.startsWith('/vehicle/');

  return (
    <>
      {showPurchaseHeader ? (
        mobileUserAgent ? (
          <PurchaseHeaderTreatment
            isMobileNative={mobileUserAgent}
            orderSummary={orderSummary}
            dashboard={dashboard}
            isOrderSummaryModalOpen={isOrderSummaryModalOpen}
            setIsOrderSummaryModalOpen={setIsOrderSummaryModalOpen}
          />
        ) : (
          <PurchaseHeader
            hideHeader={shouldHideHeader}
            orderSummary={orderSummary}
            dashboard={dashboard}
            isOrderSummaryModalOpen={isOrderSummaryModalOpen}
            setIsOrderSummaryModalOpen={setIsOrderSummaryModalOpen}
          />
        )
      ) : (
        <HeaderMfe orderSummary={orderSummary} />
      )}
    </>
  );
}

export default CarvanaHeader;
